module.exports = __webpack_public_path__ + "static/hr_capabilities_13-a72140308d3b511e6b57844252c9f46c.png";